import { useIntl } from 'react-intl'
import { useAuth } from '../../../../../contexts/AuthContext'
import { useExpertQuery } from '../../../../../services/hooks/experts/queries/useExpertQuery'
import { InternationalStepperContainer } from './components/Stepper/InternationalStepper/InternationalStepperContainer'
import { LegalStepperContainer } from './components/Stepper/LegalStepper/LegalStepperContainer'
import { NaturalStepperContainer } from './components/Stepper/NaturalStepper/NaturalStepperContainer'
import { Button } from '../../../../../components/Button'
import { usePersonalData } from '../../usePersonalData'
import { PersonTypeChangeAlert } from '../../components/PersonTypeChangeAlert'

export const PersonTypesStepper = () => {
  const { user } = useAuth()
  const { data: expert } = useExpertQuery(user?.id!)
  const {
    isChangingPersonType,
    selectedPersonType,
    isPersonTypeChangeAlertVisible,
    setIsPersonTypeChangeAlertVisible,
    handleChangePersonType,
    handleOpenPersonTypeChangeAlert,
  } = usePersonalData(expert)
  const { formatMessage } = useIntl()

  const personType = expert?.personType
  const isNaturalPerson = personType === 'natural_person'
  const isLegalPerson = personType === 'legal_person'
  const isInternationalPerson = personType === 'international_person'

  return (
    <div className="w-full lg:px-52 ">
      <div>
        <h2 className="mb-3 text-lg">{expert?.name}</h2>
        <h3 className="mb-6 text-grey-800">{expert?.email}</h3>
      </div>

      <div className="mb-6">
        <p className="max-w-[622px] text-sm font-normal text-grey-800 ">
          {formatMessage({ id: 'IN_THE_CURRENT_CONFIGURATION' })}{' '}
          <b className="text-sm font-bold text-primary-light ">
            {isNaturalPerson && formatMessage({ id: 'NATURAL_PERSON' })}
            {isLegalPerson && formatMessage({ id: 'LEGAL_PERSON' })}
            {isInternationalPerson &&
              formatMessage({ id: 'INTERNATIONAL_PERSON' })}
          </b>
          {'. '}
          {formatMessage({ id: 'IF_YOU_WANT_CHANGE_TO_ANOTHER_PAYMENT' })}
        </p>
      </div>

      <div className="flex gap-3 mb-10">
        {!isNaturalPerson && (
          <Button
            variant="outline"
            onClick={() => handleOpenPersonTypeChangeAlert('natural_person')}
          >
            {formatMessage({ id: 'NATURAL_PERSON' })}
          </Button>
        )}

        {!isLegalPerson && (
          <Button
            variant="outline"
            onClick={() => handleOpenPersonTypeChangeAlert('legal_person')}
          >
            {formatMessage({ id: 'LEGAL_PERSON' })}
          </Button>
        )}

        {!isInternationalPerson && (
          <Button
            variant="outline"
            onClick={() =>
              handleOpenPersonTypeChangeAlert('international_person')
            }
          >
            {formatMessage({ id: 'INTERNATIONAL' })}
          </Button>
        )}
      </div>

      {isNaturalPerson && <NaturalStepperContainer expert={expert} />}
      {isLegalPerson && <LegalStepperContainer expert={expert} />}
      {isInternationalPerson && (
        <InternationalStepperContainer expert={expert} />
      )}

      <PersonTypeChangeAlert
        isChangingPersonType={isChangingPersonType}
        isOpen={isPersonTypeChangeAlertVisible}
        newPersonType={selectedPersonType}
        onClose={() => setIsPersonTypeChangeAlertVisible(false)}
        onChangePersonType={handleChangePersonType}
      />
    </div>
  )
}
